<div class="dialog-box card">
  <div class="card-header">
    @if (screenShotGuide === "iosPWAInstallation") {
      Installation Guide
      @if (currentDeviceInfo?.browser === "Safari") {
        <span> for Safari 26 or higher </span>
      }
      @if (currentDeviceInfo?.browser === "Chrome") {
        <span> for Chrome </span>
      }
    }
    @if (screenShotGuide === "safariPermissionPrompts") {
      <span> Fix / Allow Permissions</span>
    }

    <span class="float-end" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  @if (guideSteps[currentStep]?.description) {
    <div>
      <div [innerHTML]="guideSteps[currentStep]?.description"></div>
    </div>
  }

  <img
    [src]="guideSteps[currentStep]?.imgSrc"
    alt="Guard Tracker"
    class="cursor-pointer mb-2"
  />

  @if (
    screenShotGuide === "safariPermissionPrompts" &&
    guideSteps?.length - 1 == currentStep
  ) {
    <div class="form-check d-flex align-items-center my-4 ms-4">
      <input
        class="form-check-input"
        type="checkbox"
        id="permissionSetting"
        [checked]="safariPermissionSettingsUpdated"
        (change)="updateSafariPermissionStatus($event)"
      />

      <label for="permissionSetting" class="ms-2"> Mark Completed </label>
    </div>
  }
  <ng-template *ngTemplateOutlet="topBtmBtns"></ng-template>
</div>

<ng-template #topBtmBtns>
  <div class="row row-cols-2">
    <div class="col">
      <button
        type="button"
        class="btn btn-secondary w-100 btn-lg"
        (click)="currentStep > 0 ? navigate(-1) : close()"
      >
        {{ currentStep > 0 ? "Back" : "Cancel" }}
      </button>
    </div>
    <div class="col">
      <button
        type="button"
        class="btn btn-lg w-100"
        [ngClass]="
          currentStep < guideSteps?.length - 1 ? 'btn-primary' : 'btn-success'
        "
        (click)="currentStep < guideSteps?.length - 1 ? navigate(1) : close()"
      >
        {{ currentStep < guideSteps?.length - 1 ? "Next" : "Close" }}
      </button>
    </div>
  </div>
</ng-template>
